<template>
  <step1 v-if="status === 'step1'"/>
  <step2 v-else-if="status === 'step2'"/>
</template>
<script setup>
import step1 from "./optSetep1.vue";
import step2 from "./optSetep2.vue";
import {computed} from "vue";
import {useStore} from 'vuex'

const store = useStore()
store.state.stepLogin = 'step1';
const status = computed(() => {
  return store.state.stepLogin;
});


</script>